window._nc_vue_element_id = window._nc_vue_element_id ?? 0;
function createElementId() {
  return `nc-vue-${window._nc_vue_element_id++}`;
}
export {
  createElementId as c
};
//# sourceMappingURL=createElementId-DhjFt1I9.mjs.map
